import React, { useState } from "react";
import { Plus } from "lucide-react";
import { trn, useI18n } from "../shared/i18n";
import { buildAllergenIconUrl } from "../allergens";

interface ProductCardProps {
  item: any;
  sectionId: number;
  openModalOrAddToCart: (item: any, menuSectionId: number) => void;
  isClicked?: boolean; // ✅ Se agrega la propiedad opcional para evitar el error
}

const ProductCard: React.FC<ProductCardProps> = ({ item, sectionId, openModalOrAddToCart, isClicked = false }) => {
  const { language } = useI18n();
  void language;
  const [clicked, setClicked] = useState(false);
  const imageUrl = item.largeImage || item.image || "";
  const allergens = Array.isArray(item.allergens) ? item.allergens : [];
  const visibleAllergens = allergens.slice(0, 3);

  const handleClick = () => {
    setClicked(true);
    openModalOrAddToCart(item, sectionId);

    setTimeout(() => {
      setClicked(false);
    }, 300); // Efecto de borde naranja por 300ms
  };

  return (
    <div
      className="consumer-product-card cursor-pointer"
      onClick={handleClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleClick();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={trn("app.consumer.product.open", "Open {product}", { product: item.name })}
    >
      <div
        className={`consumer-product-card__frame card shadow-sm p-0 text-center position-relative ${
          clicked || isClicked ? "clicked" : ""
        }`}
      >
        {item.price !== null && (
          <div
            className="consumer-product-card__price position-absolute"
            style={{
              background: "var(--dq-product-price-badge-bg, #2f2f2f)",
              color: "var(--dq-product-price-badge-text, #ffffff)",
            }}
          >
            {item.price} €
          </div>
        )}

        <div className="consumer-product-card__body card-body">
          <div className="consumer-product-card__image-wrap">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={item.name || trn("app.consumer.common.product", "Product")}
                className="consumer-product-card__image"
              />
            ) : null}
            <span className="consumer-product-card__add" aria-hidden="true">
              <Plus size={22} strokeWidth={2.8} />
            </span>
          </div>
          <h5 className="consumer-product-card__title card-title">{item.name}</h5>
          {visibleAllergens.length ? (
            <div className="consumer-product-card__allergens" aria-label={trn("app.consumer.product.allergens", "Allergens")}>
              {visibleAllergens.map((allergen: { code: string; label: string }) => (
                <span key={allergen.code} className="consumer-product-card__allergen-chip" data-allergen-code={allergen.code}>
                  <img
                    src={buildAllergenIconUrl(allergen.code)}
                    alt=""
                    aria-hidden
                    className="consumer-product-card__allergen-icon"
                    loading="lazy"
                  />
                  {allergen.label}
                </span>
              ))}
              {allergens.length > visibleAllergens.length ? (
                <span className="consumer-product-card__allergen-chip consumer-product-card__allergen-chip--muted">
                  +{allergens.length - visibleAllergens.length}
                </span>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
